class BannerSlideshow extends HTMLElement {
    connectedCallback() {
        const swiperContainer = this.querySelector('.swiper-container');
        if (!swiperContainer) return;

        // Wait until next frame or layout is painted
        requestAnimationFrame(() => {
            // Optional extra delay if needed
            setTimeout(() => {
                new Swiper(swiperContainer, {
                    centeredSlides: true,
                    loop: true,
                    speed: 500,
                    slidesPerView: 1.5,
                    spaceBetween: 40,
                    navigation: {
                        nextEl: this.querySelector('.swiper-button-next'),
                        prevEl: this.querySelector('.swiper-button-prev'),
                    },
                    pagination: {
                        el: this.querySelector('.swiper-pagination'),
                        clickable: true
                    },
                    autoplay: {
                        delay: 3000,
                        disableOnInteraction: false
                    },
                    breakpoints: {
                        0: { slidesPerView: 1, spaceBetween: 10 },
                        640: { slidesPerView: 1, spaceBetween: 10 },
                        768: { slidesPerView: 1.5, spaceBetween: 30 },
                        1080: { slidesPerView: 1.5, spaceBetween: 40 },
                        1280: { slidesPerView: 1.5, spaceBetween: 40 }
                    },
                    on: {
                        init: function () {
                            swiperContainer.classList.add('swiper-initialized');
                        }
                    }

                });
            }, 50); // Adjust delay as needed (50–100ms usually works)
        });
    }
}

customElements.define('banner-slideshow', BannerSlideshow);